"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
var theme_1 = require("../../components/theme");
exports.CSS = {
    container: 'c-RadioInput',
    label: 'c-RadioInput__label',
    disabled: 'c-RadioInput__disabled'
};
exports.Style = (_a = {},
    _a[exports.CSS.container] = {
        display: 'flex',
        'align-items': 'center'
    },
    _a[exports.CSS.disabled] = {
        color: "".concat(theme_1.DefaultTheme.font.color.error, " !important"),
        'pointer-events': 'none'
    },
    _a);
//# sourceMappingURL=radio.input.style.js.map